import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  signal,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GameService } from '../../Services/game.service';
import { GameCard } from '../../Interfaces/interfaces';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ApiCallService } from '../../Services/api-call-service.service';
import { ErrorhandlingService } from '../../Services/error-handling.service';
import { ToastrService } from 'ngx-toastr';
import {
  faUser,
  faLock,
  faEye,
  faEyeSlash,
  faCopy,
  faPlus,
  faCross,
  faXmark,
  faDownload,
  faCheck,
  faRefresh,
} from '@fortawesome/free-solid-svg-icons';
import { LoaderComponent } from '../loader/loader.component';
import { LoaderService } from '../../Services/loader-service.service';
import { LocalTimePipe } from '../../Pipes/local-time.pipe';
import { UtilsService } from '../../Services/utils.service';
import { Subject, takeUntil } from 'rxjs';
import { Router, RouterModule } from '@angular/router';
import { AddRedeemComponent } from '../../common/add-redeem/add-redeem.component';
import { GameCardComponent } from '../game-card/game-card.component';

@Component({
  selector: 'app-credentials',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    FontAwesomeModule,
    LoaderComponent,
    LocalTimePipe,
    AddRedeemComponent,
    GameCardComponent,
  ],
  templateUrl: './credentials.component.html',
  styleUrl: './credentials.component.scss',
})
export class CredentialsComponent implements OnInit, OnDestroy {
  selectedGame: any;
  scoreForm: FormGroup;
  paymentForm: FormGroup;
  captchaForm: FormGroup;
  color: string = '#00DADD';

  historyTabs: { label: string; value: '24h' | '7d' | '30d' | '12m' }[] = [
    { label: '24H', value: '24h' },
    { label: '7 DAYS', value: '7d' },
    { label: '30 DAYS', value: '30d' },
    { label: '12 MO', value: '12m' },
  ];
  historyFilter: '24h' | '7d' | '30d' | '12m' = '24h';

  selectedWallet: 'main' | 'bonus' = 'main';
  promoCode: string = '';

  get hasGameAccount(): boolean {
    return !!this.playerName;
  }

  createGameAccount(): void {
    this.addNewPlayer();
  }

  showAddScoreModal = false;
  showPaymentModal = false;
  showCaptchaModal = false;
  showDeleteAccountModal = false;
  showDeleteConfirmModal = false;
  showicon = faEye;
  hideicon = faEyeSlash;
  totalBalance: string = '100';
  showBalance: boolean = false;
  User = faUser;
  eye = faEye;
  eyeSlash = faEyeSlash;
  copy = faCopy;
  plus = faPlus;
  cross = faXmark;
  Download = faDownload;
  Lock = faLock;
  faCheck = faCheck;
  refresh = faRefresh;
  captchaImage = '/assets/captcha.png';

  history = [
    { date: '25th April 20204', time: '08:30 PM', score: '2.2' },
    { date: '5th Sept. 20204', time: '08:00 PM', score: '5.55' },
  ];

  gameAccounts = [
    {
      id: 1,
      gameName: 'Overwatch 2',
      username: 'OverwatchPro111',
      password: 'OverwatchPass111!',
      iconUrl: '/Images/game/Dragon.png',
      isPasswordVisible: false,
      isUsernameVisible: false,
    },
  ];
  getPlaceholder(): string {
    switch (this.gameName) {
      case 'GameRoom':
        return 'e.g 10';
      case 'MilkyWay':
        return 'e.g 10';
      case 'OrionStar':
        return 'e.g 10';
      case 'FireKirin':
        return 'e.g 10';
      default:
        return 'e.g 1.1';
    }
  }
  get cardBackground(): string {
    const bg = this.selectedGameDetails?.bgclr || '#00dbde';
    const c2 = this.selectedGameDetails?.color2 || '#3333ff';
    return `linear-gradient(180deg, ${bg} 0%,  #151b2b 60%, #0b0f1a 100%)`;
  }


  playerName?: any;
  playerPassword?: any;
  gameName?: any;
  gameID?: any;
  downloadLink: any;
  GameData?: any;
  constructor(
    private fb: FormBuilder,
    private Gameservice: GameService,
    private apicallservice: ApiCallService,
    private ErroHandling: ErrorhandlingService,
    private Toaster: ToastrService,
    private utilsService: UtilsService,
    private loaderService: LoaderService,
    private router: Router,
    private gameService: GameService,
    private errorHandling: ErrorhandlingService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // this.playerName = localStorage.getItem('PN');
    // this.playerPassword = localStorage.getItem('PP');
    this.constructorFunctions();
    this.scoreForm = this.fb.group({
      score: [
        '',
        [
          Validators.required,
          Validators.min(1),
          // Validators.max(1000),
          this.integerValidator.bind(this),
        ],
      ],
    });

    this.paymentForm = this.fb.group({
      requestId: [''],
      purchase: ['', Validators.required],
      confirmScore: ['', Validators.required],
    });

    this.captchaForm = this.fb.group({
      captcha: ['', Validators.required],
    });
  }
  constructorFunctions() {
    this.gameName = localStorage.getItem('GN');
    // this.gameID = localStorage.getItem('GI');
    this.GameData = this.Gameservice.getGameData();
    const allGames = this.Gameservice.getGames();
    this.selectedGameDetails = allGames?.find((data: any) => data.name === this.gameName);
  }
  integerValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const gamesToRound = ['GameRoom', 'MilkyWay', 'OrionStar', 'FireKirin'];
    if (gamesToRound.includes(this.gameName)) {
      if (Number.isInteger(value)) {
        return null;
      }
      return { notInteger: true };
    }
    return null;
  }

  private destroy$ = new Subject<void>();
  ngOnInit(): void {
    this.scrollToTopSmooth();
    this.games = this.Gameservice?.getGames();
    this.getSelectedGameData();
    this.getScoreHistory();
    this.utilsService
      .getTriggerScoreHistoryObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getScoreHistory();
      });

    this.Gameservice.getTriggerUpdatedGamesObservable().subscribe(() => {
      this.getSelectedGameData();
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  selectedPlayerId: number = 0;
  captchaCode: any;
  selectedGameDetails: any;
  getSelectedGameData() {
    const gameData = this.Gameservice.getArrayInLocalStorage('bis_data');
    if (this.GameData) {
      var selectedGameData = gameData.find(
        (data: any) => data.GameName === this.GameData?.GameName,
      );
    } else {
      var selectedGameData = gameData.find(
        (data: any) => data.GameName === this.gameName,
      );
    }
    const offerData = this.Gameservice.getArrayInLocalStorage('bis_offer');
    if (this.GameData) {
      var selectedGameOfferData = offerData.find(
        (data: any) => data.GameName === this.GameData?.GameName,
      );
      if (selectedGameOfferData) {
        this.offerOnGame = selectedGameOfferData.Bonus;
        this.upToScore = selectedGameOfferData.UptoScore;
      }
    } else {
      var selectedGameOfferData = offerData.find(
        (data: any) => data.GameName === this.gameName,
      );
      if (selectedGameOfferData) {
        this.offerOnGame = selectedGameOfferData.Bonus;
        this.upToScore = selectedGameOfferData.UptoScore;
        this.IsOnUpdate = selectedGameOfferData.IsOnUpdate == 'True';
      }
    }

    this.playerName = selectedGameData?.PlayerName || '';
    this.playerPassword = selectedGameData?.PlayerPassword || '';
    this.gameID = selectedGameData?.GameID || 0;
    this.selectedPlayerId = selectedGameData?.PlayerName || 0;
    this.downloadLink = selectedGameData?.downloadLink || '';
    this.IsOnUpdate = selectedGameOfferData?.IsOnUpdate == 'True';
    if (selectedGameData && selectedGameOfferData) {
      selectedGameData.GameId = selectedGameOfferData?.GameId;
    }
    this.selectedGameData = selectedGameData ?? selectedGameOfferData;
  }
  IsOnUpdate: boolean = false;
  selectedGameData: any;
  offerOnGame: number = 0;
  upToScore: number = 0;
  user = faUser;
  lock = faLock;
  openAddScoreModal(): void {
    this.showBalance = false;
    this.scoreForm.reset();
    this.AddScorePayload().tCode = '';
    this.tCode = '';
    this.AddScorePayload().capatchaCode = '';
    this.showAddScoreModal = true;
    this.currentScore = '';
    this.requestId = '';
    this.getScoreforAddding();
    // if (!this.isAddScoreDisable) {
    //   this.showAddScoreModal = true;
    // } else {
    //   const gameName =
    //     this.GameData?.GameName != undefined
    //       ? this.GameData?.GameName
    //       : this.gameName;
    //   this.Toaster.warning(
    //     'Your deposit request of ' + gameName + ' already in process',
    //     'Previous pending requests '
    //   );
    // }
  }

  closeAddScoreModal(): void {
    this.showAddScoreModal = false;
  }
  // updatedGivenScore: number = 0;
  // get roundedUpdatedGivenScore(): number {
  //   const gamesToRound = ['GameRoom', 'MilkyWay', 'OrionStar', 'FireKirin'];
  //   if (gamesToRound.includes(this.gameName)) {
  //     return Math.floor(this.updatedGivenScore);
  //   }
  //   return this.updatedGivenScore;
  // }

  updatedGivenScore: number = 0;

  // get roundedUpdatedGivenScore(): number {
  //   const gamesToRound = ['GameRoom', 'MilkyWay', 'OrionStar', 'FireKirin'];
  //   if (gamesToRound.includes(this.gameName)) {
  //     this.updatedGivenScore = Math.floor(this.updatedGivenScore);
  //   }
  //   return this.updatedGivenScore;
  // }

  get roundedUpdatedGivenScore(): number {
    this.updatedGivenScore = Math.floor(this.updatedGivenScore);
    return this.updatedGivenScore;
  }
  onScoreSubmit(): void {
    if (this.scoreForm.valid) {
      this.addedScore = this.scoreForm?.value?.score;
      // const bonus = (this.upToScore * this.offerOnGame) / 100;
      // this.updatedGivenScore = Number(this.addedScore) + bonus;
      let bonus: number = 0;
      if (this.addedScore > this.upToScore) {
        bonus = (this.upToScore * this.offerOnGame) / 100;
      } else {
        bonus = this.offerOnGame
          ? (this.addedScore * this.offerOnGame) / 100
          : 0;
      }
      this.updatedGivenScore = this.addedScore + bonus;

      this.closeAddScoreModal();
      this.showPaymentModal = true;
    }
  }

  toggleVisibility(account: any): void {
    account.isUsernameVisible = !account.isUsernameVisible;
    account.isPasswordVisible = !account.isPasswordVisible;
  }

  async copyCredentials(account: any): Promise<void> {
    const textToCopy = `Username: ${this.playerName}, Password: ${this.playerPassword}`;
    try {
      await navigator.clipboard.writeText(textToCopy);
      // console.log('Copied to clipboard!');
      this.Toaster.info('Copied to clipboard!', 'info');
    } catch (err) {
      // console.error('Failed to copy text: ', err);
    }
  }

  isCopied = signal(false);
  CopyToClipBoard(text: string) {
    navigator.clipboard.writeText(text);
    this.isCopied.set(true);
    setTimeout(() => {
      this.isCopied.set(false);
    }, 2000);
  }

  closePaymentModal(): void {
    this.showPaymentModal = false;
    this.paymentForm.reset();
  }

  onPaymentSubmit(): void {
    if (this.paymentForm.valid) {
      this.PalyerSubmit();
      // this.showCaptchaModal = true;
    }
  }

  closeCaptchaModal(): void {
    this.showCaptchaModal = false;
    this.captchaForm.reset();
  }

  onCaptchaSubmit(): void {
    if (this.captchaForm.valid) {
      if (this.isBalanceShown) {
      } else {
        // Handle final submission
        this.PalyerSubmit();
        // Add success notification or further processing here
      }
    } else {
      this.captchaForm.markAllAsTouched();
    }
  }

  //////////////////for game image
  getGameImage(gameName: string): string {
    const game = this.games.find((g: any) => g.name === gameName);
    return game ? game.image : ''; // Return empty string if no game is found
  }
  playGame(downloadLink: any): void {
    const game = this.games.find((g: any) => g.name === downloadLink);
    if (game && game.downloadLink) {
      // Open the download link in a new tab
      window.open(game.downloadLink, '_blank');
    } else {
      // console.error('Game not found or download link is missing');
    }
  }

  // playGame(downloadLink:any):any{
  //   const game = this.games.find((g:any) => g.id ==downloadLink );
  //   return game ? game.downloadLink : '';
  // }
  games: any = [];

  ///////////////////Add Game Score Api call

  IsScoreValid() {
    if (this.scoreForm.valid) {
      if (
        this.currentScore === '' ||
        this.currentScore === null ||
        this.currentScore === undefined
      ) {
        this.Toaster.warning(
          'Get Current Score to complete Add Score Request.',
        );
      } else if (this.currentScore >= 3) {
        this.Toaster.warning(
          `Score Must be less than 3 to add more score. Your current Score is ${this.currentScore}.`,
        );
      } else {
        this.onScoreSubmit();
      }
    }
  }

  getCustomerID(): number | null {
    return Number(localStorage.getItem('customerId'));
  }

  //////////////////////////////////For Non PlayerName Games Modal
  OpenCaptchaAddPlayer(details: any) {
    this.showCaptchaModal = true;
    // this.payloadaddnewPlayer(details)
  }

  CloseCaptchaAddPlayer() {
    this.showCaptchaModal = false;
    this.AddScorePayload().tCode = '';
    this.tCode = '';
    this.AddScorePayload().capatchaCode = '';
  }
  AddScorePayload() {
    // 1.
    const bisOfferData = localStorage.getItem('bis_offer');
    const offerList = bisOfferData ? JSON.parse(bisOfferData) : [];

    // 2.
    const selectedGame = offerList.find(
      (game: any) => game.GameName === this.gameName,
    );
    this.selectedGame = selectedGame;
    // 3.
    const gameId = selectedGame ? selectedGame.GameId : 0;
    return {
      gameName: this.gameName || 0,
      gameId: gameId, // <-- New Field Added
      customerID: this.getCustomerID()?.toString(),
      playerID: this.selectedPlayerId || 0,
      addScore:
        this.addedScore?.toString() || this.scoreForm?.value?.score?.toString(),
      capatchaCode: '0',
      tCode: this.tCode,
      source: `AddScore,${this.gameName}`,
      totalScore: this.updatedGivenScore.toString(),
      bonus: '0',
      requestId: this.requestId?.toString(),
    };
  }
  tCode: string = '';
  addedScore: any;
  firstPendingIndex: number = -1;

  getFirstPendingIndex(): number {
    return this.ScoreHistory?.findIndex((e) => e.Status === 1) ?? -1;
  }
  timerValue: number = 59;
  showTimer: boolean = false;
  timerInterval: any;

  isAddScoreDisabled: boolean = false;
  startTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.isAddScoreDisabled = true;
    this.showTimer = true;
    this.timerValue = 59;

    this.timerInterval = setInterval(() => {
      this.timerValue--;
      if (this.timerValue <= 0) {
        clearInterval(this.timerInterval);
        this.showTimer = false;
        // this.Toaster.success('Your score was added successfully!', 'Success');
      }
    }, 1000);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
    this.isAddScoreDisabled = false;
    this.showTimer = false;
  }

  PalyerSubmit() {
    this.loaderService.show();
    const payload = this.AddScorePayload();
    // payload.addScore = this.updatedGivenScore;
    // payload.capatchaCode = this.captchaForm?.value?.captcha?.toString() || '';
    this.closePaymentModal();
    if (this.selectedGame.IsOnUpdate == 'True') {
      this.ErroHandling.showAlert(
        'warning',
        'Game is under update!. Please try again later.',
      );
      return;
    }
    // setTimeout(() => {
    //    ;
    //   this.getScoreHistory();
    // }, 4000);

    this.apicallservice
      .PostCallWithToken(payload, 'AddGameScore/AddGameScore')
      .subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            this.Toaster.success(response.responseMessage, 'Success');
            this.getScoreHistory();
            this.closePaymentModal();
            // this.startTimer(); // Start 59 sec timer

            this.loaderService.hide();
            this.loaderService?.triggerWalletFunction();
            this.closeCaptchaModal();
            // if (this.showBalance) {
            //   this.showScore();
            // }
            this.getScoreHistory();
          } else {
            this.ErroHandling.handleResponseError(response);
            this.loaderService.hide();
            this.getScoreHistory();
          }
        },
        (error) => {
          this.ErroHandling.handleHttpError(error);
          this.loaderService.hide();
          this.getScoreHistory();
        },
      );
  }
  getcustomerId(): number | null {
    return Number(localStorage.getItem('customerId'));
  }
  ScoreHistory: any[] = [];
  isAddScoreDisable: boolean = false;
  getScoreHistory() {
    // this.loaderService.show();
    const payload = {
      pageNumber: this.currentPage,
      pageSize: 10,
      customerId: this.getcustomerId(),
      gameName: this.GameData?.GameName || this.gameName,
    };
    this.apicallservice
      .PostCallWithToken(payload, 'GameInfo/GetScoreHistory')
      .subscribe((response) => {
        if (response.responseCode === 200) {
          // this.ScoreHistory = [...this.ScoreHistory, ...response.data];
          // this.games = [...this.games, ...response.data];
          const combinedGames = [...this.ScoreHistory, ...response.data];

          // Sort combinedGames by AddedDate
          combinedGames.sort(
            (b, a) =>
              new Date(a.AddedDate).getTime() - new Date(b.AddedDate).getTime(),
          );

          this.ScoreHistory = Array.from(
            new Map(combinedGames.map((game: any) => [game.Id, game])).values(),
          );
          // check the status from pervious request
          const isPendingScore = this.ScoreHistory.find(
            (data) => data.Status === 1,
          );

          if (isPendingScore) {
            this.isAddScoreDisable = true;
          }

          // Start timer for frist index

          if (this.ScoreHistory && this.ScoreHistory.length > 0) {
            const first = this.ScoreHistory[0];

            // Check status
            const isPending = first.Status === 1;

            const isRequetsType =
              first?.RequestType?.toLowerCase() == 'automation';

            if (isPending && isRequetsType) {
              this.firstPendingIndex = 0;
              this.startTimer();
            } else {
              this.firstPendingIndex = -1;
              this.stopTimer();
            }
          } else {
            this.stopTimer();
          }

          // End timer for frist index

          this.totalRecords =
            response?.data.totalRecords || response?.data?.length;
          this.calculatePages();
          this.loaderService.hide();
        } else {
          if (this.currentPage) {
            this.currentPage--;
          }
          this.apicallservice.handleError(response);
          this.loaderService.hide();
        }
      });
  }

  // TS Code for Pagination Start
  pages: (number | string)[] = [];
  currentPage: number = 1;
  totalRecords: number = 0;
  itemsPerPage: number = 10;
  maxVisiblePages: number = 1;

  calculatePages(): void {
    const totalPages = Math.ceil(this.totalRecords / this.itemsPerPage);
    this.pages = [];
    if (totalPages <= this.maxVisiblePages) {
      this.pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      const startPage = Math.max(
        this.currentPage - Math.floor(this.maxVisiblePages / 2),
        1,
      );
      const endPage = Math.min(
        startPage + this.maxVisiblePages - 1,
        totalPages,
      );

      if (startPage > 1) {
        this.pages.push(1);
        if (startPage > 2) {
          this.pages.push('...');
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        this.pages.push(i);
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          this.pages.push('...');
        }
        this.pages.push(totalPages);
      }
    }
  }

  navigateToPage(page: any): void {
    if (
      (page >= 1 && page <= this.pages.length) ||
      (page >= 1 && page >= this.pages.length)
    ) {
      this.currentPage = page;
      this.getScoreHistory();
    }
  }

  navigatePage(direction: 'prev' | 'next'): void {
    if (direction === 'prev' && this.currentPage > 1) {
      this.currentPage--;
    } else if (
      direction === 'next' &&
      this.currentPage < Math.ceil(this.totalRecords / this.itemsPerPage)
    ) {
      this.currentPage++;
    }
    this.getScoreHistory();
  }

  getDisplayRange(): string {
    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(start + this.itemsPerPage - 1, this.totalRecords);
    return `${start} – ${end}`;
  }

  // TS Code for Pagination End

  cards = [
    { date: '09/01/2025, 06:24 PM', amount: '', status: 'Pending' },
    { date: '21/09/2024, 10:50 PM', amount: '5.0', status: 'Completed' },
    { date: '21/09/2024, 08:57 PM', amount: '5.0', status: 'Completed' },
    { date: '21/09/2024, 03:09 PM', amount: '5.0', status: 'Completed' },
  ];

  //? Scroll Functionality
  @ViewChild('credentialsWebContainer', { static: false })
  credentialsWebContainer!: ElementRef;

  credentialWebScroll(): void {
    const element = this.credentialsWebContainer.nativeElement;

    // Calculate if scrolled to the bottom
    const isAtBottom =
      Math.ceil(element.scrollTop + element.offsetHeight) >=
      element.scrollHeight;

    if (isAtBottom) {
      this.currentPage++;
      // console.log('Scrolled to bottom');
      this.currentPage++;
      this.getScoreHistory();
    }
  }

  //? Mobile Scroll Functionality
  @ViewChild('credentialsMobileContainer', { static: false })
  credentialsMobileContainer!: ElementRef;
  credentialMobileScroll(): void {
    // console.log('scrolling');
    const element = this.credentialsMobileContainer.nativeElement;
    //? Calculate if scrolled to the bottom
    const isAtBottom =
      Math.ceil(element.scrollTop + element.offsetHeight) >=
      element.scrollHeight;
    if (isAtBottom) {
      // console.log('Scrolled to bottom');
      this.currentPage++;
      this.getScoreHistory();
    }
  }

  getBalanceScore: any = {
    id: 0,
    gameUserID: '',
    agentcode: '',
    t: 0,
  };

  gameBalance: number = 0;

  isBalanceShown: boolean = false;

  showedBalance() {
    this.showBalance = !this.showBalance;
    this.isBalanceShown = false;
    const balanceElement = document.getElementById('balance');
    balanceElement!.textContent = this.showBalance
      ? `$${this.gameBalance}`
      : '•••••';
  }
  isCaptchaGames(gameName: string): boolean {
    return ['GameVault', 'Juwa', 'Vegas', 'GameRoom'].includes(gameName);
  }

  RedirectToRedeem() {
    this.requestId = '';
    this.showBalance = false;
    this.openRedeemModal(this.gameName);
    // this.router.navigate(['/dashboard/redeem']);
  }
  openRedeemModal(gameName: string) {
    this.selectedGame = gameName;
    this.showRedeemModal = true;
  }
  showRedeemModal: boolean = false;
  closeRedeemModal() {
    this.showRedeemModal = false;
  }

  scoreValue: any;
  isGetScoreLoading: boolean = false;
  isGetScoreFailed400: boolean = false;
  showScore() {
    this.showBalance = false;
    // this.loaderService.show();
    this.isGetScoreLoading = true;
    this.isGetScoreFailed400 = false;
    const payload = this.showScorePayload();
    this.apicallservice
      .PostCallWithToken(payload, 'AddGameScore/GetGameScore')
      .subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            this.showBalance = true;
            this.scoreValue = response?.data;
            this.isGetScoreLoading = false;
            this.isGetScoreFailed400 = false;
          } else if (response && response.responseCode === 400) {
            // Show a retry icon instead of an error popup when API returns 400
            this.isGetScoreLoading = false;
            this.isGetScoreFailed400 = true;
          } else {
            // other non-200 responses: keep default handling
            this.isGetScoreLoading = false;
            this.isGetScoreFailed400 = false;
          }
        },
        (error) => {
          this.ErroHandling.handleHttpError(error);
          this.isGetScoreLoading = false;
          this.isGetScoreFailed400 = false;
        },
      );
  }
  showScorePayload() {
    // 1.
    const bisOfferData = localStorage.getItem('bis_offer');
    const offerList = bisOfferData ? JSON.parse(bisOfferData) : [];

    // 2.
    const selectedGame = offerList.find(
      (game: any) => game.GameName === this.gameName,
    );

    // 3.
    const gameId = selectedGame ? selectedGame.GameId : 0;
    return {
      gameName: this.gameName || 0,
      gameId: gameId,
      customerID: this.getCustomerID()?.toString(),
      playerID: this.selectedPlayerId || 0,
    };
  }

  currentScore: any;
  isScoreLoading: boolean = false;
  getScoreforAddding() {
    // this.loaderService.show();
    this.isScoreLoading = true;
    const payload = this.showScorePayload();
    this.apicallservice
      .PostCallWithToken(payload, 'AddGameScore/GetGameScore')
      .subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            this.currentScore = response?.data;
            this.isScoreLoading = false;
          } else {
            // this.ErroHandling.handleResponseError(response);
            this.isScoreLoading = false;
            this.currentScore = 'allow';
          }
        },
        (error) => {
          this.ErroHandling.handleHttpError(error);
          this.isScoreLoading = false;
          this.currentScore = 'allow';
        },
      );
  }
  requestId: any;
  handleRetry(record: any, event: Event): void {
    event.stopPropagation();

    if (record.ActionType === 'Score') {
      this.addedScore = record.Score;
      this.updatedGivenScore = record.TotalScore;
      this.requestId = record.RequestId;
      console.log(this.requestId);
      this.showPaymentModal = true;
      // this.scoreRetry()
    } else if (record.ActionType === 'Redeem') {
      this.selectedGame = this.gameName;
      this.showRedeemModal = true;
      this.requestId = record.RequestId;
      // this.retryRedeemRequest(record);
    }
  }
  // Score Retry

  // scoreRetry(){
  //   this.addedScore = ''
  //   this.updatedGivenScore = 0
  //   this.showPaymentModal = true;

  openDeleteAccountModal() {
    this.showDeleteAccountModal = true;
  }

  closeDeleteAccountModal() {
    this.showDeleteAccountModal = false;
  }

  confirmDeleteAccount() {
    this.showDeleteAccountModal = false;
    this.showDeleteConfirmModal = true;
  }

  closeDeleteConfirmModal() {
    this.showDeleteConfirmModal = false;
  }

  deleteAccount() {
    this.loaderService.show();
    // this.addNewPlayer();
    const gameID = this.gameID;
    this.apicallservice
      .DeleteCallWithToken(`GamePlayer/DeleteUserGameAccount/${gameID}`)
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            // this.Toaster.success(
            //   response.responseMessage || 'Account deleted successfully',
            //   'Success'
            // );
            // Now automatically create a new player
            this.addNewPlayer();
          } else {
            this.loaderService.hide();
            this.ErroHandling.handleResponseError(response);
          }
        },
        error: (error) => {
          this.loaderService.hide();
          this.ErroHandling.handleHttpError(error);
        },
      });
  }
  addPlayerPayload() {
    return {
      id: this.selectedGameData?.systemgameid ?? this.selectedGameData?.GameId,
      gameName: this.gameName,
      customerID: this.getCustomerID(),
      playerUserName: '',
      playerPassword: '',
      rechargeBalance: 0,
      gameId:
        this.selectedGameData?.systemgameid ?? this.selectedGameData?.GameId,
    };
  }

  getCustomerName(): string {
    return localStorage.getItem('userName') || '';
  }
  addNewPlayer() {
    this.loaderService.show();
    const payload = this.addPlayerPayload();
    if (payload.playerUserName == '') {
      payload.playerUserName = this.generateGameAccountIdentifier(
        this.getCustomerName(),
        payload.gameName,
      );
    }
    if (payload.playerPassword == '') {
      payload.playerPassword = this.generateGameIdentifier(payload.gameName);
    }
    if (this.IsOnUpdate) {
      this.loaderService.hide();
      this.ErroHandling.showAlert(
        'warning',
        'Game is under update!. Please try again later.',
      );
      return;
    }
    this.apicallservice
      .PostCallWithToken(payload, 'AddGameScore/CreatePanelPlayer')
      .subscribe({
        next: (response) => {
          this.loaderService.hide();
          if (response && response.responseCode === 200) {
            // this.Toaster.success(
            //   'New game account created successfully',
            //   'Success'
            // );
            this.getGameAccount();
            // this.getSelectedGameData();
            this.showDeleteConfirmModal = false;
          } else {
            this.ErroHandling.handleResponseError(response);
          }
        },
        error: (error) => {
          this.loaderService.hide();
          this.ErroHandling.handleHttpError(error);
        },
      });
  }
  private scrollToTopSmooth(): void {
    try {
      // Use smooth scrolling when supported
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      // Fallback for older browsers/environments
      try {
        window.scrollTo(0, 0);
      } catch {
        // ignore
      }
    }
  }

  //     generateGameAccountIdentifier(CustomerName: string, gameId: any): string {
  //     // 1. Clean the name: Remove anything that isn't a letter or number
  //     let cleanedName = CustomerName.replace(/[^a-zA-Z0-9]/g, () => {
  //       return String.fromCharCode(97 + Math.floor(Math.random() * 26));
  //     });

  //     // --- NEW FIX START ---
  //     // if only numbers
  //     if (/^\d+$/.test(cleanedName)) {
  //       // replce first 2 with alpahbet
  //       const randomChar1 = String.fromCharCode(97 + Math.floor(Math.random() * 26));
  //       const randomChar2 = String.fromCharCode(97 + Math.floor(Math.random() * 26));

  //       cleanedName = randomChar1 + randomChar2 + cleanedName.slice(2);
  //     }
  //     // --- NEW FIX END ---

  //     // Then take the first 5 chars
  //     let prefix: string = cleanedName.slice(0, 5).toLowerCase();

  //     // 2. Pad if shorter than 5
  //     if (prefix.length < 5) {
  //       const charsNeeded = 5 - prefix.length;
  //       for (let i = 0; i < charsNeeded; i++) {
  //         prefix += String.fromCharCode(97 + Math.floor(Math.random() * 26));
  //       }
  //     }

  //     // 3. Get game initials
  //     let gameInitials: string = this.utilsService.gameNameInitials(gameId);

  //     // 4. Generate the 3 random components (2 digits, 1 letter)
  //     const digit1 = Math.floor(Math.random() * 10).toString();
  //     const digit2 = Math.floor(Math.random() * 10).toString();
  //     const letter = String.fromCharCode(97 + Math.floor(Math.random() * 26));

  //     // 5. Place them in an array and shuffle
  //     let components = [digit1, digit2, letter];
  //     for (let i = components.length - 1; i > 0; i--) {
  //       const j = Math.floor(Math.random() * (i + 1));
  //       [components[i], components[j]] = [components[j], components[i]];
  //     }

  //     // 6. Join the shuffled components and return
  //     const randomPart = components.join('');
  //     return `${prefix}${randomPart}${gameInitials}`;
  // }

  generateGameAccountIdentifier(CustomerName: string, gameId: any): string {
    // 1. Clean the name: Replace special characters with random letters
    let cleanedName = CustomerName.replace(/[^a-zA-Z0-9]/g, () => {
      return String.fromCharCode(97 + Math.floor(Math.random() * 26));
    });

    // 2. If username starts with numbers, replace the first 2 characters with random letters
    // Examples:
    // 1234abcd -> xy34abcd
    // 12test   -> abtest
    // 99999    -> cd999
    if (/^\d/.test(cleanedName)) {
      const randomChar1 = String.fromCharCode(
        97 + Math.floor(Math.random() * 26)
      );
      const randomChar2 = String.fromCharCode(
        97 + Math.floor(Math.random() * 26)
      );

      if (cleanedName.length >= 2) {
        cleanedName = randomChar1 + randomChar2 + cleanedName.slice(2);
      } else {
        cleanedName = randomChar1 + randomChar2;
      }
    }

    // 3. Take first 5 chars
    let prefix: string = cleanedName.slice(0, 5).toLowerCase();

    // 4. Pad if shorter than 5
    while (prefix.length < 5) {
      prefix += String.fromCharCode(
        97 + Math.floor(Math.random() * 26)
      );
    }

    // 5. Get game initials
    const gameInitials: string =
      this.utilsService.gameNameInitials(gameId);

    // 6. Generate random part (2 digits + 1 letter)
    const digit1 = Math.floor(Math.random() * 10).toString();
    const digit2 = Math.floor(Math.random() * 10).toString();
    const letter = String.fromCharCode(
      97 + Math.floor(Math.random() * 26)
    );

    const components = [digit1, digit2, letter];

    // Shuffle
    for (let i = components.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [components[i], components[j]] = [components[j], components[i]];
    }

    const randomPart = components.join('');

    return `${prefix}${randomPart}${gameInitials}`;
  }
  generateGameIdentifier(gameId: any): string {
    let prefix: string = this.utilsService.gameNameInitials(gameId);
    const randomDigits = Math.floor(1000 + Math.random() * 9000); // Generates a random 4-digit number
    const randomLetters =
      String.fromCharCode(97 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(97 + Math.floor(Math.random() * 26)); // Generates 2 random lowercase letters

    // return `${prefix}${randomLetters}${randomDigits}`;
    const combined = `${prefix}${randomLetters}${randomDigits}`;
    return combined.charAt(0).toUpperCase() + combined.slice(1); // Ensure first character is uppercase
  }
  getGameAccount() {
    const customerID = localStorage.getItem('customerId');

    const payload = 'Game/GetGameUserInfo?CustomerId=' + customerID;
    this.apicallservice.GetCallWithToken(payload).subscribe(
      (response) => {
        if (response && response.responseCode === 200) {
          this.gameAccounts = response.data;
          this.loaderService.setArrayInLocalStorage('bis_data', response.data);
          this.games.forEach((game: any) => {
            const getPlayerGames = response.data;
            const matchedGame = getPlayerGames.find(
              (matchingGame: any) => matchingGame.GameName === game.name,
            );
            if (matchedGame) {
              this.getSelectedGameData();
            }
          });
        } else {
          this.ErroHandling.handleResponseError(response);
        }
      },
      (error) => {
        this.ErroHandling.handleHttpError(error);
      },
    );
  }

  get filteredScoreHistory(): any[] {
    const now = new Date().getTime();
    let ms = 0;
    switch (this.historyFilter) {
      case '24h':
        ms = 24 * 60 * 60 * 1000;
        break;
      case '7d':
        ms = 7 * 24 * 60 * 60 * 1000;
        break;
      case '30d':
        ms = 30 * 24 * 60 * 60 * 1000;
        break;
      case '12m':
        ms = 365 * 24 * 60 * 60 * 1000;
        break;
      default:
        ms = 0;
        break;
    }
    if (!ms) return this.ScoreHistory;
    return this.ScoreHistory.filter((entry: any) => {
      const t = new Date(entry.AddedDate).getTime();
      return now - t <= ms;
    });
  }

  get moreGames(): any[] {
    const all = [...this.Gameservice.getGames(), ...this.Gameservice.SystemGames];
    return all.filter((g: any) => g.name !== this.gameName);
  }

  getStatus(game: any): { label: string; active: boolean } {
    const link = game?.downloadLink || '';
    if (link.startsWith('/') || game?.isHot) {
      return { label: 'ACTIVE', active: true };
    }
    return { label: 'PLAY', active: false };
  }

  playMoreGame(game: any): void {
    if (!game?.name) return;

    // if (isPlatformBrowser(this.platformId)) {
    localStorage.setItem('GN', game.name);
    // }

    const offerData = this.Gameservice.getArrayInLocalStorage('bis_offer');
    const matchedOffer = offerData.find(
      (g: any) => g.GameName === game.name
    );

    if (matchedOffer?.IsOnUpdate === 'True') {
      this.ErroHandling.showAlert(
        'warning',
        'Game is under update!. Please try again later.'
      );
      return;
    }

    this.Gameservice.setGameData({
      GameName: game?.name,
      GameId: game?.id,
      IsOnUpdate: matchedOffer?.IsOnUpdate || 'False',
    });

    // Reset everything to initial state, same as freshly entering credentials
    this.playerName = '';
    this.playerPassword = '';
    this.gameID = 0;
    this.selectedPlayerId = 0;
    this.downloadLink = '';
    this.selectedGameData = null;
    this.scoreValue = 0;
    this.currentScore = '';
    this.requestId = '';
    this.addedScore = null;
    this.updatedGivenScore = 0;
    this.ScoreHistory = [];
    this.showBalance = false;
    this.offerOnGame = 0;
    this.upToScore = 0;
    this.historyFilter = '24h';

    this.constructorFunctions();
    this.scrollToTopSmooth();
    this.getSelectedGameData();
    this.getScoreHistory();
  }

  scrollToHistory(): void {
    const el = document.getElementById('gameHistorySection');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollMoreGames(direction: number): void {
    const track = document.getElementById('moreGamesTrack');
    if (track) {
      track.scrollBy({ left: direction * 320, behavior: 'smooth' });
    }
  }
}
